import {CommonStatus} from "@/enums/status";

export class ArticleParams {
    page? = 1;
    limit? = 10;
    search?: string;
    status? = CommonStatus.Active;
    postOfficeRowGuid?: string;
}
